import * as React from "react"
const SvgEkoIllusDunk3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 1163 820"
    }}
    viewBox="0 0 1163 820"
    {...props}>
    <style>
      {
        ".pl_st1{opacity:.4;fill:#fff}.pl_st2{stroke-linecap:round;stroke-linejoin:round}.pl_st2,.pl_st3{fill:none;stroke:#2d0e5e;stroke-width:4;stroke-miterlimit:10}.pl_st9{opacity:.2;fill:#2d0e5e}.pl_st16{fill:none;stroke:#2d0e5e;stroke-width:2;stroke-miterlimit:10}.pl_st28{fill:#e4e4ef}.pl_st29,.pl_st30,.pl_st31{stroke:#2d0e5e;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.pl_st29{fill:#ed4848;stroke-linejoin:round}.pl_st30,.pl_st31{fill:none}.pl_st31{stroke-linejoin:round}.pl_st32,.pl_st33{fill:#111616}.pl_st33{stroke-width:1.5}.pl_st33,.pl_st34,.pl_st35{stroke:#111616;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pl_st34{fill:none;stroke-width:1.5}.pl_st35{fill:#111616}.pl_st36{display:none}.pl_st38{display:inline}.pl_st39{fill:#e0d5b5;stroke:#5b480e;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pl_st52{fill:#dbdbdb}.pl_st53{fill:#4d4d4d}.pl_st54,.pl_st55{fill:#2e2e8b;stroke:#2e2e8b;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pl_st55{fill:none;stroke:#4d4d4d}.pl_st58,.pl_st61{display:inline;fill:#477c4e}.pl_st61{fill:#ddf2ee}.pl_st62{fill:#fff}.pl_st62,.pl_st63{display:inline}.pl_st63,.pl_st71{fill:#a6ac5d}.pl_st72{fill:#c5df8d}.pl_st100,.pl_st97,.pl_st98,.pl_st99{fill:#a7c4db;stroke:#a7c4db;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.pl_st100,.pl_st98,.pl_st99{fill:#072e44;stroke:#072e44}.pl_st100,.pl_st99{fill:#13496d;stroke:#13496d}.pl_st100{fill:none}.pl_st101{fill:#13496d}.pl_st102,.pl_st107{stroke-miterlimit:10}.pl_st102{fill:#c2e6f5;stroke:#c2e6f5;stroke-linecap:round;stroke-linejoin:round}.pl_st107{fill:none;stroke:#a6ac5d;stroke-width:2}.pl_st108{fill:#477c4e}.pl_st123{fill:#ccb99a}.pl_st124{fill:#a58265}.pl_st125{fill:#a17b60}.pl_st126{fill:#845550}.pl_st127{fill:#26662c}.pl_st128{fill:#334724}.pl_st129{fill:#6c5410}.pl_st130{fill:#7ab929}.pl_st131{fill:#efb76b}.pl_st132{fill:#b8753a}"
      }
    </style>
    <g id="pl_Lager_1">
      <path
        d="M1044.9 502.1c-37.6-33.1-122.1-29.4-149.9-42.5-5.6-2.6-11.2-5.1-16.7-7.3.3-.6.6-1.3.9-1.9 23.2-64.6-97.3-53.7-81.2-71.5 19.9-22.1-7-45.7 8.5-60.8 59.3-57.9-87.1-46.6-87.1-46.6-49.1 28.9-95.3 54.7-98.8 14.7 0-5.8-1.3-11-4.2-15.6 0 0-5-.4-7.3-.6 2.3.2 7.3.6 7.3.6-.7-1.2-1.6-2.3-2.4-3.3-1.1-3.3-.1-8.9 11.4-16.6.6-.4 1.1-.7 1.7-1.1 1-.7 2-1.3 2.9-1.9 10-6.9 19.4-14.9 27.3-23.6 25.5-28.3 24.7-53-1.8-55.2-26.5-2.2-68.8 19-94.3 47.3-9.4 10.4-15.2 20.3-17.5 28.7-.1.2-.1.4-.2.6-.6 2-3.1 8.2-11.1 11.9-50.5 13.3-109.9 49.2-149.7 93.4-12.8 14.2-22.4 27.9-28.8 40.6-.3.4-.5.8-.7 1.3-10.8 20.8-49 49.4-62.7 53.6-.5.1-1 .3-1.5.4h-.1c-25.9 7-58.4 26.8-84.8 52-35.4 3.1-70.3 15.9-85.7 33-15.6 17.3-6.7 33.7 19.2 41.7h.1c.4.1.9.3 1.3.4 11 3.9 13 21.7-7.9 32.1l-1.2.6c-13.1 6.3-23.7 13.5-30.8 21.4-22.2 24.6-4.4 48.8 40 62.1 4.4 2.8-2.8 5.8-5.4 6.7-.3.1-.6.2-.8.3-11.3 3.9-20.4 8.9-25.6 14.7-14.2 15.8 5.8 31.2 44.7 34.3s82-7 96.2-22.8c4.4-4.8 5.5-9.6 3.9-14.1-.1-.4-.3-.8-.5-1.2-.1-.2-.3-.5-.4-.7-2.3-5 6-7.5 13-8.7 3-.3 6-.6 8.9-1 0 0-6.4-.5-10-.8 3.6.3 10 .8 10 .8 11.5-1.5 22.2-3.4 32-5.9 19.7-4.4 89.6-11.9 101-6.3 14.1 7-82 27-14.7 50.2 8.8 3 11.4 16.8 24.2 23.5 4.3 2.6 9.2 4.9 15 6.6 16.9 6.2 38.6 10.7 64.1 12.8 2.1.2 4.2.3 6.4.4v.3h7.2c3.6.1 29.8 0 42.8-7.3 24.9-14.2 20.6-32.4 41.5-36.7 34.3-7.1 41.6 5.4 136.8 30.1 9.4 2.4 20.5 5.6 33.7 6.7 28.6 2.3 59.6-1.7 84.3-10 10.1 5 24.2 8.5 41.5 10 48.6 4 104.1-10.6 123.8-32.5 19.8-21.9-3.6-42.9-52.3-46.9-1-.1-2-.2-3-.2-.7-.1-1.5-.1-2.3-.2-30.8-2.5-3.8-13.2 10.8-18.1 26.8-8.1 48-18.9 59.3-31.5 20-22.2 4.3-44.3-35.8-58.6 25.3-8.6 87-54.1 55.5-81.8zm-705.4-74.9c-4 7.2-9.9 14.1-17.9 16.4l17.9-16.4zM851.1 695c.5-1.5.8-3 .9-4.5h3.1s15.1 1.7 13 9.1c-4.9-1.9-10.6-3.4-17-4.6z"
        style={{
          opacity: 0.7,
          fill: "#e0d2fc"
        }}
      />
      <path
        d="m657.9 32.7-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L654 326c23.1-14.1 23.1-25.4 23.1-41.9V64.2c.1-13.7-7.3-25.8-19.2-31.5z"
        className="pl_st28"
      />
      <path d="m498.1 100.7 27.1-15.5" className="pl_st3" />
      <path
        d="m525.2 85.2-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pl_st2"
      />
      <path
        d="m645.8 79.5-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9.1 1.6 15.5-12.1 23.5z"
        className="pl_st9"
      />
      <path
        d="m591.7 168.7-72.9 97.6 72.9 57.3 72.9-98.2z"
        className="pl_st1"
      />
      <path
        d="M521 102.5c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V166c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pl_st2"
      />
      <path
        d="m645.8 79.5-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9.1 1.6 15.5-12.1 23.5z"
        className="pl_st16"
      />
      <path
        d="M468.3 131.3c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9 15.8 0 28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pl_st29"
      />
      <path
        d="M470.8 146.5c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pl_st30"
      />
      <path
        d="M512.4 393.5c-9.5 3.5-9.5-3.4-9.5-3.4V205.2c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pl_st31"
      />
      <path
        d="m592.8 177.2 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.1-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pl_st32"
      />
      <path
        d="M565.7 279.1s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8V246s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6s-3 2.5-3.2 2.6-1.5-.6-1.4-.8c.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6.7 0 1.7.3 2.1-.2.4-.5-.2-4.1-1.3-5.3s-5.5-2.4-6.6-3.3c-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4s-.1-6.7-1.1-8.8c-1-2.1-2.7-4.1-3.6-4.4-.9-.3-1.1-1-.9-1.3.2-.3.7-1 .7-1.1 0-.1.5 0 .7.2.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3s1.2 3.9 1.3 4.5.9 2.2 1.6 1.8c.7-.3 2.7-5.2 3.2-6.2s1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7-.3-.9-.6-3.7-.5-4s1-.8 1.3-1 .8 0 .9.7c.1.6.9 5.9.8 7.5s.1 3.2.3 3c.2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5s1.1-.3 1.1.3-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5-.5.9-2.4 3.7-3 4.6s-1.8 2.9-1.8 2.9.4 4.7.1 6.1-1.5 5.1-2 6.2c-.4 1.1-.9 2.6-.7 2.5s3.2-5 4.1-5.7 5-2.2 6.2-3.7c1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2.1.2-.8 2.8-1 3.6s-3.9 8-4.4 8.7-1.5 2.5-2.8 3.3-3.5 2-4.5 3.7c-1.1 1.8-6.3 9.8-6.3 10 0 .2.1 15.7.2 16 .2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2s-2.6 1.5-3.6 4.4c-1 2.9-1.9 5.6-2.1 5.8-.2.2-.9-1.3-1.1-1.8-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5-.8.7-1.7 1.7-2.8 2.2-.6.4-3.3 2.3-5 2.7z"
        className="pl_st33"
      />
      <path
        d="M601.9 268.6s8.4-11.3 16.4-20.3 12.9-13.1 14.8-10.6-3.7 10.7-7.5 13.9c-3.9 3.2-17.1 13.7-23.7 17z"
        className="pl_st34"
      />
      <path
        d="M631.6 244.2c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M606.4 262.6s.1-4.2-4.8-3.3c-4.9.8-7.3 6.3-7.6 7.2-.3.9-1.7 5.1-1.8 6.1"
        className="pl_st34"
      />
      <path
        d="M594.1 272.4s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6c3.4-2.4 3.5-6 3.5-6s4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pl_st34"
      />
      <path
        d="m589 280.5-3.6 1.4-6.2-3.1M588.5 282.6l-2.2 2.5s-5.5-1.7-6.8-2M595.3 267s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M592.4 271.2s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M599.7 262.7s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M606.4 251.9s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pl_st34"
      />
      <path
        d="M601.1 259.4s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3 2.3-3.7 5-8.6 5-8.6"
        className="pl_st34"
      />
      <path
        d="M614.1 228.8s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="pl_st34"
      />
      <path
        d="M616.2 250.6s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM619.5 234.3s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pl_st35"
      />
      <path
        d="M604.3 251.7s-1.7-6.9-2.1-7.5c-.4-.5-2.9-2.5-2.9-2.5M596.5 262.4s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pl_st34"
      />
      <path
        d="M590.4 277s4.5-2.1 3.4 1.1c-1.1 3.1-3.4-1.1-3.4-1.1zM602.6 255.8s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7H602l-.5-.8 1.1-2.6z"
        className="pl_st35"
      />
      <path
        d="M475.4 119c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9V132c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pl_st29"
      />
      <path
        d="M484.9 128.5v13.8M494.9 129.9v12.4M502.9 128.5v13.3M510.4 125.9v13.4"
        className="pl_st30"
      />
      <path
        d="m773.3 113.3-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4L654 147c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2V420c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0l128.3-72.9c23.1-14.1 23.1-25.4 23.1-41.9V144.8c.1-13.7-7.3-25.7-19.2-31.5z"
        className="pl_st28"
      />
      <path d="m613.6 181.3 27-15.5" className="pl_st3" />
      <path
        d="m640.6 165.8-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pl_st2"
      />
      <path
        d="m761.2 160.2-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pl_st9"
      />
      <path d="m707.1 249.3-72.9 97.6 72.9 57.3L780 306z" className="pl_st1" />
      <path
        d="M636.4 183.1c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V246.6c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pl_st2"
      />
      <path
        d="m761.2 160.2-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pl_st16"
      />
      <path
        d="M583.8 211.9c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9 15.8 0 28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pl_st29"
      />
      <path
        d="M586.2 227.1c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pl_st30"
      />
      <path
        d="M627.8 474.1c-9.5 3.5-9.5-3.4-9.5-3.4V285.8c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pl_st31"
      />
      <path
        d="m708.2 257.8 63.4 49.3-65.6 88.5-63.4-49.9 65.6-87.9m-1.1-8.5-72.9 97.5 72.9 57.3L780 306l-72.9-56.7z"
        className="pl_st32"
      />
      <path
        d="M681.2 359.7s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8v-22.3s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6-.2.1-1.5-.6-1.4-.8.1-.2 1.8-2.7 5.5-4.6s6.5-.6 7.1-.6c.7 0 1.7.3 2.1-.2s-.2-4.1-1.3-5.3c-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4-.9-.3-1.1-1-.9-1.3.2-.3.7-1 .7-1.1 0-.1.5 0 .7.2.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5s1-3.5 1.1-4.1c.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8s.4.3.4 1.6-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8s2.7-5.2 3.2-6.2 1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7-.3-.9-.6-3.7-.5-4s1-.8 1.3-1c.4-.2.8 0 .9.7.1.6.9 5.9.8 7.5 0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5.2-.2 1.1-.3 1.1.3s-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1c-.2 1.4-1.5 5.1-2 6.2-.4 1.1-.9 2.6-.7 2.5s3.2-5 4.1-5.7c.9-.7 5-2.2 6.2-3.7s5-7.6 5.4-8.5c.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2.1.2-.8 2.8-1 3.6s-3.9 8-4.4 8.7c-.5.8-1.5 2.5-2.8 3.3-1.3.8-3.5 2-4.5 3.7s-6.3 9.8-6.3 10c0 .2.1 15.7.2 16s5.3 1.6 9.6 1.1c0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2s-2.6 1.5-3.6 4.4-1.9 5.6-2.1 5.8c-.2.2-.9-1.3-1.1-1.8s-1.7-1.4-3.1-.6c-1.4.9-3.4 1.8-4.1 2.5s-1.7 1.7-2.8 2.2c-.7.4-3.3 2.3-5 2.7z"
        className="pl_st33"
      />
      <path
        d="M717.3 349.2s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9s-17.1 13.7-23.7 17z"
        className="pl_st34"
      />
      <path
        d="M747 324.8c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M721.8 343.2s.1-4.2-4.8-3.3c-4.9.8-7.3 6.3-7.6 7.2-.3.9-1.7 5.1-1.8 6.1"
        className="pl_st34"
      />
      <path
        d="M709.5 353s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6c3.4-2.4 3.5-6 3.5-6s4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pl_st34"
      />
      <path
        d="m704.4 361.1-3.6 1.4-6.2-3.1M703.9 363.2l-2.2 2.5s-5.5-1.7-6.8-2M710.8 347.6s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M707.9 351.8s-3.5-.1-4.2-.5-2.1-2.3-2.1-2.3M715.2 343.3s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M721.8 332.5s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pl_st34"
      />
      <path
        d="M716.5 340s3.3-7.5 4.1-10.2 2-7.6 4.2-11.3c2.3-3.7 5-8.6 5-8.6"
        className="pl_st34"
      />
      <path
        d="M729.6 309.4s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="pl_st34"
      />
      <path
        d="M731.7 331.2s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM734.9 314.9s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pl_st35"
      />
      <path
        d="M719.7 332.3s-1.7-6.9-2.1-7.5c-.4-.5-2.9-2.5-2.9-2.5M711.9 343s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pl_st34"
      />
      <path
        d="M705.8 357.6s4.5-2.1 3.4 1.1c-1.1 3.1-3.4-1.1-3.4-1.1zM718 336.4s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="pl_st35"
      />
      <path
        d="M590.9 199.6c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9S621.2 181 607.9 181s-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pl_st29"
      />
      <path
        d="M600.4 209.1v13.8M610.3 210.5v12.4M618.4 209.1v13.3M625.8 206.5v13.4"
        className="pl_st30"
      />
      <path
        d="m887.9 193.7-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L884 487c23.1-14.1 23.1-25.4 23.1-41.9V225.2c.1-13.6-7.3-25.7-19.2-31.5z"
        className="pl_st28"
      />
      <path d="m728.2 261.7 27.1-15.4" className="pl_st3" />
      <path
        d="m755.3 246.3-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pl_st2"
      />
      <path
        d="M875.8 240.6 795 281.5c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.5 15.5-12.2 23.5z"
        className="pl_st9"
      />
      <path
        d="m821.7 329.8-72.9 97.5 72.9 57.3 72.9-98.1z"
        className="pl_st1"
      />
      <path
        d="M751 263.6c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9L755.8 560c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V327c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pl_st2"
      />
      <path
        d="M875.8 240.6 795 281.5c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.5 15.5-12.2 23.5z"
        className="pl_st16"
      />
      <path
        d="M698.4 292.4c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9 15.8 0 28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pl_st29"
      />
      <path
        d="M700.9 307.6c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pl_st30"
      />
      <path
        d="M742.4 554.6c-9.5 3.5-9.5-3.4-9.5-3.4V366.3c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pl_st31"
      />
      <path
        d="m822.9 338.3 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.2-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pl_st32"
      />
      <path
        d="M795.8 440.2s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8V407s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6s-1.5-.6-1.4-.8c.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6.7 0 1.7.3 2.1-.2.4-.5-.2-4.1-1.3-5.3-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4-.9-.3-1.1-1-.9-1.3.2-.3.7-1 .7-1.1s.5 0 .7.2c.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9s.5-.5.7-.8c.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8.7-.3 2.7-5.2 3.2-6.2s1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7s-.6-3.7-.5-4c.1-.3 1-.8 1.3-1s.8 0 .9.7.9 5.9.8 7.5c0 1.6.1 3.2.3 3s3.1-4.5 3.4-5.2c.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5.2-.2 1.1-.3 1.1.3s-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6-1.8 2.9-1.8 2.9.4 4.7.1 6.1-1.5 5.1-2 6.2c-.4 1.1-.9 2.6-.7 2.5s3.2-5 4.1-5.7c.9-.7 5-2.2 6.2-3.7s5-7.6 5.4-8.5c.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2.1.2-.8 2.8-1 3.6s-3.9 8-4.4 8.7-1.5 2.5-2.8 3.3c-1.3.8-3.5 2-4.5 3.7-1.1 1.8-6.3 9.8-6.3 10s.1 15.7.2 16c.2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2-.7.4-2.6 1.5-3.6 4.4-1 2.9-1.9 5.6-2.1 5.8-.2.2-.9-1.3-1.1-1.8s-1.7-1.4-3.1-.6c-1.4.9-3.4 1.8-4.1 2.5-.8.7-1.7 1.7-2.8 2.2-.7.5-3.3 2.4-5 2.8z"
        className="pl_st33"
      />
      <path
        d="M831.9 429.6s8.4-11.3 16.4-20.3 12.9-13.1 14.8-10.6c1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.3-17.1 13.7-23.7 17z"
        className="pl_st34"
      />
      <path
        d="M861.6 405.3c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M836.5 423.7s.1-4.2-4.8-3.3c-4.9.8-7.3 6.3-7.6 7.2s-1.7 5.1-1.8 6.1"
        className="pl_st34"
      />
      <path
        d="M824.2 433.4s-3.3.6-5.3 1.8c-2 1.2-5.2 2.5-5.7 2.5 0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6c3.4-2.4 3.5-6 3.5-6s4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pl_st34"
      />
      <path
        d="m819 441.6-3.6 1.4-6.1-3.2M818.5 443.6l-2.2 2.5s-5.5-1.7-6.8-2M825.4 428.1s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M822.5 432.3s-3.5-.1-4.2-.5-2.1-2.3-2.1-2.3M829.8 423.8s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M836.4 413s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pl_st34"
      />
      <path
        d="M831.1 420.4s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3 2.3-3.7 5-8.6 5-8.6"
        className="pl_st34"
      />
      <path
        d="M844.2 389.9s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="pl_st34"
      />
      <path
        d="M846.3 411.6s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM849.5 395.3s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pl_st35"
      />
      <path
        d="M834.4 412.8s-1.7-6.9-2.1-7.5c-.4-.5-2.9-2.5-2.9-2.5M826.5 423.4s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pl_st34"
      />
      <path
        d="M820.4 438.1s4.5-2.1 3.4 1.1c-1.1 3.1-3.4-1.1-3.4-1.1zM832.7 416.9s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="pl_st35"
      />
      <path
        d="M705.5 280c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9V293c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pl_st29"
      />
      <path
        d="M715 289.6v13.8M724.9 291v12.4M733 289.6v13.3M740.4 287v13.4"
        className="pl_st30"
      />
      <path
        d="m423.5 164.6-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L419.6 458c23.1-14.1 23.1-25.4 23.1-41.9V196.2c.1-13.8-7.3-25.8-19.2-31.6z"
        className="pl_st28"
      />
      <path d="m263.8 232.6 27-15.5" className="pl_st3" />
      <path
        d="m290.8 217.1-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pl_st2"
      />
      <path
        d="m411.4 211.5-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pl_st9"
      />
      <path
        d="m357.3 300.7-72.9 97.5 72.9 57.3 72.9-98.2z"
        className="pl_st1"
      />
      <path
        d="M286.6 234.4c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6V416c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V297.9c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pl_st2"
      />
      <path
        d="m411.4 211.5-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        className="pl_st16"
      />
      <path
        d="M234 263.2c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9 15.8 0 28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pl_st29"
      />
      <path
        d="M236.4 278.5c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pl_st30"
      />
      <path
        d="M278 525.4c-9.5 3.5-9.5-3.4-9.5-3.4V337.1c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pl_st31"
      />
      <path
        d="m358.4 309.2 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.1-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pl_st32"
      />
      <path
        d="M331.3 411.1s6.8-5.7 8-7 3-3.8 3-3.8V378s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6-.2.1-1.5-.6-1.4-.8.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6s1.7.3 2.1-.2-.2-4.1-1.3-5.3c-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4s-1.1-1-.9-1.3c.2-.3.7-1 .7-1.1 0-.1.5 0 .7.2.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6s.5 1.6.8 1.5c.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8s.4.3.4 1.6-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8.7-.3 2.7-5.2 3.2-6.2s1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7-.3-.9-.6-3.7-.5-4 .1-.3 1-.8 1.3-1 .4-.2.8 0 .9.7s.9 5.9.8 7.5c0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7s1.3-3.3 1.5-3.5 1.1-.3 1.1.3-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1c-.2 1.4-1.5 5.1-2 6.2-.4 1.1-.9 2.6-.7 2.5.2-.1 3.2-5 4.1-5.7.9-.7 5-2.2 6.2-3.7 1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4s.5.1.6.2c.1.2-.8 2.8-1 3.6-.2.8-3.9 8-4.4 8.7-.5.8-1.5 2.5-2.8 3.3-1.3.8-3.5 2-4.5 3.7s-6.3 9.8-6.3 10c0 .2.1 15.7.2 16 .2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2-.7.4-2.6 1.5-3.6 4.4-1 2.9-1.9 5.6-2.1 5.8s-.9-1.3-1.1-1.8c-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5s-1.7 1.7-2.8 2.2-3.3 2.3-5 2.7z"
        className="pl_st33"
      />
      <path
        d="M367.5 400.5s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.3-17.1 13.7-23.7 17z"
        className="pl_st34"
      />
      <path
        d="M397.2 376.2c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M372 394.5s.1-4.2-4.8-3.3-7.3 6.3-7.6 7.2c-.3.9-1.7 5.1-1.8 6.1"
        className="pl_st34"
      />
      <path
        d="M359.7 404.3s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7c.2.6 3.7 5.1 7.1 2.6s3.5-6 3.5-6 4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pl_st34"
      />
      <path
        d="m354.6 412.4-3.6 1.4-6.2-3.1M354.1 414.5l-2.2 2.5s-5.5-1.7-6.8-2M360.9 398.9s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M358 403.2s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M365.3 394.7s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M372 383.8s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pl_st34"
      />
      <path
        d="M366.7 391.3s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3 2.3-3.7 5-8.6 5-8.6"
        className="pl_st34"
      />
      <path d="M379.7 360.8s4.2 2.1 5.2 4.9 2 9.9-2 15.6" className="pl_st34" />
      <path
        d="M381.8 382.5s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM385.1 366.2s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pl_st35"
      />
      <path
        d="M369.9 383.6s-1.7-6.9-2.1-7.5-2.9-2.5-2.9-2.5M362.1 394.3s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pl_st34"
      />
      <path
        d="M356 408.9s4.5-2.1 3.4 1.1-3.4-1.1-3.4-1.1zM368.2 387.8s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="pl_st35"
      />
      <path
        d="M241 250.9c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pl_st29"
      />
      <path
        d="M250.5 260.4v13.9M260.5 261.8v12.5M268.5 260.4v13.3M276 257.9v13.3"
        className="pl_st30"
      />
      <path
        d="m538.9 245.2-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4L419.6 279c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L535 538.5c23.1-14.1 23.1-25.4 23.1-41.9V276.7c.1-13.7-7.3-25.7-19.2-31.5z"
        className="pl_st28"
      />
      <path d="m379.2 313.2 27.1-15.4" className="pl_st3" />
      <path
        d="m406.3 297.8-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pl_st2"
      />
      <path
        d="M526.8 292.1 446 333c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1.9 9 1.5 15.4-12.2 23.5z"
        className="pl_st9"
      />
      <path
        d="m472.7 381.3-72.9 97.5 72.9 57.3 72.9-98.2z"
        className="pl_st1"
      />
      <path
        d="M402 315c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V378.5c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pl_st2"
      />
      <path
        d="M526.8 292.1 446 333c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1.9 9 1.5 15.4-12.2 23.5z"
        className="pl_st16"
      />
      <path
        d="M349.4 343.8c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9 15.8 0 28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pl_st29"
      />
      <path
        d="M351.8 359.1c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pl_st30"
      />
      <path
        d="M393.4 606c-9.5 3.5-9.5-3.4-9.5-3.4V417.8c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pl_st31"
      />
      <path
        d="m473.9 389.8 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.2-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pl_st32"
      />
      <path
        d="M446.8 491.7s6.8-5.7 8-7 3-3.8 3-3.8v-22.3s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6-.2.1-1.5-.6-1.4-.8.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6s1.7.3 2.1-.2-.2-4.1-1.3-5.3c-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4s-1.1-1-.9-1.3c.2-.3.7-1 .7-1.1 0-.1.5 0 .7.2.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6s.5 1.6.8 1.5c.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8s.4.3.4 1.6-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8.7-.3 2.7-5.2 3.2-6.2s1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7-.3-.9-.6-3.7-.5-4 .1-.3 1-.8 1.3-1 .4-.2.8 0 .9.7s.9 5.9.8 7.5c0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7s1.3-3.3 1.5-3.5 1.1-.3 1.1.3-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1c-.2 1.4-1.5 5.1-2 6.2-.4 1.1-.9 2.6-.7 2.5.2-.1 3.2-5 4.1-5.7.9-.7 5-2.2 6.2-3.7 1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4s.5.1.6.2c.1.2-.8 2.8-1 3.6-.2.8-3.9 8-4.4 8.7-.5.8-1.5 2.5-2.8 3.3-1.3.8-3.5 2-4.5 3.7s-6.3 9.8-6.3 10c0 .2.1 15.7.2 16 .2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2-.7.4-2.6 1.5-3.6 4.4-1 2.9-1.9 5.6-2.1 5.8s-.9-1.3-1.1-1.8c-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5s-1.7 1.7-2.8 2.2-3.3 2.3-5 2.7z"
        className="pl_st33"
      />
      <path
        d="M482.9 481.1s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.3-17.1 13.7-23.7 17z"
        className="pl_st34"
      />
      <path
        d="M512.6 456.8c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M487.4 475.2s.1-4.2-4.8-3.3-7.3 6.3-7.6 7.2c-.3.9-1.7 5.1-1.8 6.1"
        className="pl_st34"
      />
      <path
        d="M475.1 484.9s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7c.2.6 3.7 5.1 7.1 2.6s3.5-6 3.5-6 4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pl_st34"
      />
      <path
        d="m470 493-3.6 1.4-6.1-3.1M469.5 495.1l-2.2 2.5s-5.5-1.7-6.8-2M476.4 479.5s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M473.5 483.8s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M480.8 475.3s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M487.4 464.4s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="pl_st34"
      />
      <path
        d="M482.1 471.9s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3 2.3-3.7 5-8.6 5-8.6"
        className="pl_st34"
      />
      <path d="M495.2 441.4s4.2 2.1 5.2 4.9 2 9.9-2 15.6" className="pl_st34" />
      <path
        d="M497.3 463.1s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM500.5 446.8s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pl_st35"
      />
      <path
        d="M485.3 464.2s-1.7-6.9-2.1-7.5-2.9-2.5-2.9-2.5M477.5 474.9s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pl_st34"
      />
      <path
        d="M471.4 489.5s4.5-2.1 3.4 1.1-3.4-1.1-3.4-1.1zM483.6 468.4s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7H483l-.5-.8 1.1-2.6z"
        className="pl_st35"
      />
      <path
        d="M356.5 331.5c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pl_st29"
      />
      <path
        d="M366 341v13.9M375.9 342.4v12.5M384 341v13.3M391.4 338.5v13.3"
        className="pl_st30"
      />
      <path
        d="m653.5 325.7-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8l-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0L649.7 619c23.1-14.1 23.1-25.4 23.1-41.9V357.2c0-13.7-7.3-25.7-19.3-31.5z"
        className="pl_st28"
      />
      <path d="m493.8 393.7 27.1-15.5" className="pl_st3" />
      <path
        d="m520.9 378.2-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="pl_st2"
      />
      <path
        d="m641.4 372.6-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1.1 9 1.6 15.4-12.1 23.5z"
        className="pl_st9"
      />
      <path
        d="m587.3 461.8-72.9 97.5 72.9 57.3 72.9-98.2z"
        className="pl_st1"
      />
      <path
        d="M516.6 395.5c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V459c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="pl_st2"
      />
      <path
        d="m641.4 372.6-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1.1 9 1.6 15.4-12.1 23.5z"
        className="pl_st16"
      />
      <path
        d="M464 424.3c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9s28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="pl_st29"
      />
      <path
        d="M466.5 439.5c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="pl_st30"
      />
      <path
        d="M508.1 686.5c-9.5 3.5-9.5-3.4-9.5-3.4V498.2c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        className="pl_st31"
      />
      <path
        d="m588.5 470.2 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.2-8.4-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        className="pl_st32"
      />
      <path
        d="M561.4 572.2s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8V539s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6s-1.5-.6-1.4-.8c.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6.7 0 1.7.3 2.1-.2.4-.5-.2-4.1-1.3-5.3-1.1-1.2-5.5-2.4-6.6-3.3s-2.9-1.4-3.7-1.4c-.8-.1-1.5-.4-1.5-.7 0-.2.7-1.1.9-1.2s3.4.2 3.9.6 2.4 1.6 3.7 1.5c1.3-.1 2.2-.1 2.4-.4s-.1-6.7-1.1-8.8c-1-2.1-2.7-4.1-3.6-4.4-.9-.3-1.1-1-.9-1.3.2-.3.7-1 .7-1.1s.5 0 .7.2c.2.3 1.9 1.3 2.6 1.6s1.6 1.6 2.1 2.6c.5.9.5 1.6.8 1.5.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3s1.2 3.9 1.3 4.5c.2.6.9 2.2 1.6 1.8s2.7-5.2 3.2-6.2 1.9-3.2 1.6-5.3c-.2-2.2-.5-11.8-.8-12.7s-.6-3.7-.5-4 1-.8 1.3-1 .8 0 .9.7c.1.6.9 5.9.8 7.5 0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5.2-.2 1.1-.3 1.1.3s-1 3.3-1.5 4.4-1.8 4.1-2.3 5-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1c-.2 1.4-1.5 5.1-2 6.2s-.9 2.6-.7 2.5c.2-.1 3.2-5 4.1-5.7.9-.7 5-2.2 6.2-3.7 1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2s-.8 2.8-1 3.6c-.2.8-3.9 8-4.4 8.7-.5.8-1.5 2.5-2.8 3.3s-3.5 2-4.5 3.7c-1.1 1.8-6.3 9.8-6.3 10s.1 15.7.2 16c.2.3 5.3 1.6 9.6 1.1 0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9-1.2.2-2.8.8-3.5 1.2s-2.6 1.5-3.6 4.4c-1 2.9-1.9 5.6-2.1 5.8-.2.2-.9-1.3-1.1-1.8-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5-.8.7-1.7 1.7-2.8 2.2-.7.5-3.3 2.3-5 2.8z"
        className="pl_st33"
      />
      <path
        d="M597.5 561.6s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.2-17.1 13.7-23.7 17z"
        className="pl_st34"
      />
      <path
        d="M627.2 537.2c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M602.1 555.6s.1-4.2-4.8-3.3c-4.9.8-7.3 6.3-7.6 7.2-.3.9-1.7 5.1-1.8 6.1"
        className="pl_st34"
      />
      <path
        d="M589.8 565.4s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6c3.4-2.4 3.5-6 3.5-6s4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="pl_st34"
      />
      <path
        d="m584.6 573.5-3.6 1.4-6.1-3.1M584.1 575.6l-2.2 2.5s-5.5-1.7-6.8-2M591 560s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M588.1 564.2s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M595.4 555.7s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M602 544.9s-.6-12.2-1.3-13.1-2.8-3.3-2.8-3.3"
        className="pl_st34"
      />
      <path
        d="M596.7 552.4s3.3-7.5 4.1-10.2c.8-2.7 2-7.6 4.2-11.3 2.3-3.7 5-8.6 5-8.6"
        className="pl_st34"
      />
      <path d="M609.8 521.9s4.2 2.1 5.2 4.9 2 9.9-2 15.6" className="pl_st34" />
      <path
        d="M611.9 543.6s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM615.1 527.3s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="pl_st35"
      />
      <path
        d="M600 544.7s-1.7-6.9-2.1-7.5c-.4-.5-2.9-2.5-2.9-2.5M592.1 555.4s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="pl_st34"
      />
      <path
        d="M586 570s4.5-2.1 3.4 1.1-3.4-1.1-3.4-1.1zM598.3 548.8s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="pl_st35"
      />
      <path
        d="M471.1 412c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9V425c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="pl_st29"
      />
      <path
        d="M480.6 421.5v13.9M490.5 422.9v12.5M498.6 421.5v13.3M506 418.9v13.4"
        className="pl_st30"
      />
      <path
        d="m617.2 641.1.7 9.2c.8 10.6 6.3 20.4 15 26.7l67.9 45.7c4.4 3.2 13.2 3.5 21.6 2.3l25.3 15c.7 1.6 1.5 3.2 2.4 4.8 6.3 10.8 15.3 17.4 20.2 14.6l5.2-2.9 24.6 14.5c11.2 6.6 25 6.8 36.1.6l141-78.9c13.4-7.5 21.6-21.6 21.5-37l-.2-36.8c-.1-15.1-8.2-29.2-21.4-37l-119.7-71.1c-22.4-12.4-31.6-7.2-45 .3L633.8 611c-11.2 6.3-17.5 17.8-16.6 30.1z"
        className="pl_st28"
      />
      <path d="M747.7 739.9 722.4 725" className="pl_st3" />
      <path
        d="m722.4 725 25.3 15c.7 1.6 1.5 3.2 2.4 4.8 6.3 10.8 15.3 17.4 20.2 14.6l5.2-2.9"
        className="pl_st2"
      />
      <path
        d="m661 629.6 71.4 47.1c7.4 4.9 6.6 12.6-1.6 17.2-8 4.5-20.1 4.1-27.1-.6L638 648.8c-6.5-4.4-8.7-13.5-1.9-18.3 6.9-5 11.9-8.4 24.9-.9z"
        className="pl_st9"
      />
      <path
        d="m759.1 632.9 113.6 14.9 12.3-85.3-114.2-14.6z"
        className="pl_st1"
      />
      <path
        d="M738.5 720.5c-9.5 4.6-30.1 7.6-37.7 2.1L632.9 677c-8.7-6.3-14.2-16.1-15-26.7l-.7-9.2c-.9-12.3 5.4-23.8 16.6-30.1l178.9-100.1c13.4-7.5 22.6-12.6 45-.3l119.7 71.1c13.2 7.8 21.4 21.9 21.4 37l.2 36.8c.1 15.4-8.1 29.5-21.5 37l-141 78.9c-11.2 6.3-25 6-36.1-.6l-24.6-14.5"
        className="pl_st2"
      />
      <path
        d="m661 629.6 71.4 47.1c7.4 4.9 6.6 12.6-1.6 17.2-8 4.5-20.1 4.1-27.1-.6L638 648.8c-6.5-4.4-8.7-13.5-1.9-18.3 6.9-5 11.9-8.4 24.9-.9z"
        className="pl_st16"
      />
      <path
        d="M786.7 750.2c2.3 1.7 4.2 2.4 5.4 1.7l12.2-6.8c5.8-3.2 4.5-16.2-3-29-7.4-12.8-18.1-20.6-23.9-17.3l-12.2 6.8c-1.2.7-1.6 2.6-1.3 5.4"
        className="pl_st29"
      />
      <path
        d="M797.9 741.3c-.2-5.5-2.5-12.6-6.5-19.7-7.4-12.8-18.1-20.6-23.9-17.3"
        className="pl_st30"
      />
      <path
        d="M979.2 595.1c7.3 6.1 1.7 9.2 1.7 9.2l-150.4 84.1c-11.2 6.3-25 6-36.1-.6l-14.8-8.3-107.9-70.8"
        className="pl_st31"
      />
      <path
        d="m775.9 554.6 102.3 13-10.6 73.4-101.8-13.3 10.1-73.1m-5.1-6.7-11.7 85 113.7 14.9 12.3-85.3-114.3-14.6z"
        className="pl_st32"
      />
      <path
        d="M861.1 603.8s-7.9-2.9-9.5-3.3c-1.6-.3-4.5-.7-4.5-.7l-15.5 8.6-2.7 1.5s-2.2 2-.2 5.7c1.9 3.7 2.3 3.7 3.1 4.3.8.6 3.4 1.3 3.6 1.4s.3 1.5 0 1.5c-.2 0-3.1-.3-6.3-2.4s-3.6-5-3.9-5.5-.5-1.5-1.1-1.6c-.6-.1-3.2 2-3.7 3.4s.6 5.6.5 6.8c-.2 1.2.3 3 .6 3.7s.4 1.4.2 1.5-1.2-.1-1.4-.2c-.1-.1-1.4-2.9-1.4-3.5 0-.6.2-2.7-.6-3.7s-1.1-1.8-1.4-1.8c-.4-.1-5.4 3.1-6.6 4.9-1.2 1.7-2 4-1.9 4.9.2.9-.3 1.4-.7 1.3s-1.1-.1-1.2-.1-.3-.4-.2-.7c.1-.3.1-2.2.1-2.8 0-.7.5-2 1.1-2.9.5-.8 1.1-1.1.8-1.3-.3-.2-3.3.7-3.9 1-.6.2-2.2.9-2.7.7-.4-.1-.7-.2-.9-.2s.1-.5 1.1-1c1-.6 6.2-2.1 6.4-2.3.2-.2 6.4-5.1 7.4-6.5 1-1.4 2.6-2.7 3.1-3.2.4-.4 1.3-1.7.7-2.1-.6-.4-5.5.2-6.6.2-1.1 0-3.5-.1-5.1 1.1-1.7 1.2-9.4 5.8-9.9 6.4s-2.8 2.2-3.1 2.2c-.3.1-1.1-.4-1.5-.6-.3-.2-.3-.6.1-1s4.3-3.4 5.7-4.1 2.6-1.5 2.3-1.6-5.1-.5-5.8-.4c-.7 0-6 .1-7 .4s-3.3.4-3.6.4c-.3-.1-.8-.8-.3-1 .5-.3 3.2-.7 4.3-.8s4.2-.4 5.1-.4 4.2.3 5.2.4 3.2.2 3.2.2 3.6-2.4 4.9-2.9c1.3-.4 4.9-1.1 5.9-1.2 1.1-.1 2.5-.5 2.3-.6s-5.6-.3-6.6-.7c-1-.4-4.2-3.1-5.9-3.4-1.7-.3-8.5-.6-9.5-.5-1 .1-4.3 0-4.8-.1s-.2-.4-.1-.6c.1-.1 2.6-.6 3.4-.8.8-.2 8.3-.5 9.2-.4s2.7 0 4 .8c1.3.7 3.2 1.9 5.2 2 2 .1 10.9.7 11.1.6.2-.1 12.8-7.2 12.9-7.5.1-.3-1.2-5-3.7-8.3 0 0 .3-.1.6 0s3.2 2.5 4 3.4c.7.9 2 1.9 2.6 2.3s2.5 1.4 5.3.9 5.5-1 5.7-1c.2.1-.6 1.3-.9 1.7-.3.4-.4 2 1 2.8 1.4.8 3.1 1.9 4 2.2.9.3 2.2.6 3.1 1.3s3.7 2 4.9 3.2z"
        className="pl_st33"
      />
      <path
        d="M835.5 579.2s-13.1-1.7-24.2-4.1c-11.1-2.4-16.7-4.6-15.6-7.3s10.5-1.8 14.8-.2c4.4 1.7 19.2 7.8 25 11.6z"
        className="pl_st34"
      />
      <path
        d="M801.7 566.2c-.3-.6-.4-1.1-.1-1.7 1.1-2.7 10.2-1.2 14.4.8 3.3 1.5 12.6 6.2 19.2 10.3M828.5 578.2s-3.4 1.8-.4 5.4c3 3.6 8.6 3 9.5 2.9s5-.9 5.8-1.3"
        className="pl_st34"
      />
      <path
        d="M842.2 583.8s2 2.4 4 3.5 4.5 3 4.7 3.4c0 0 .2-1.3 0-1.7s1-2.2 1.4-2.6 2.4-5.3-1.2-7c-3.6-1.7-6.5-.1-6.5-.1s-3.4-2.9-6.6-3.5-5.6.2-7.1.8"
        className="pl_st34"
      />
      <path
        d="m851.2 584.3 2.9 2.3.3 6.4M853.2 583.8l3.1.7s1.2 5.2 1.6 6.5M837.3 585.3s3.2 3 2.7 4.2-3.4 3.2-3.4 3.2M842.1 585.7s1.6 2.9 1.5 3.6c0 .8-.9 2.8-.9 2.8M831.7 583.6s-6.6 3.9-7 4.8-.1 4.2-.1 4.2M819.8 583.2s-9.7 6-10 7-1.4 3.8-1.4 3.8"
        className="pl_st34"
      />
      <path
        d="M828.3 584s-7.6.7-10.2 1.3c-2.6.5-7.1 1.9-11.2 1.7-4-.2-9.4-.1-9.4-.1"
        className="pl_st34"
      />
      <path
        d="M797.4 587.3s-.2-4.3 1.5-6.4 7.1-6.1 13.7-5.5"
        className="pl_st34"
      />
      <path
        d="M814 575.8s-5.3 4 3.1 9.8l-6.1 1.2c-8.6-5.1-5.2-10.4-5.2-10.4l2.9-.8 5.3.2zM799.2 580.5s-.5 4.8 4.2 6.4h-5.5l-.6-.6.3-2.7.6-1.7 1-1.4z"
        className="pl_st35"
      />
      <path
        d="M820.6 584.9s-4.8 4.6-5.1 5.1c-.2.6-.6 3.5-.6 3.5M832.9 586.4s-2.8 2.1-2.8 2.9.3 3.1.3 3.1"
        className="pl_st34"
      />
      <path
        d="M847.7 584.7s-3.9-2.7-.7-3.3c3.1-.5.7 3.3.7 3.3zM824.7 584.4s-4.2-4.2-2.4-7.2l5.6 1.1-1.1 2.1.1 1.5.9 1.5-.4.8-2.7.2z"
        className="pl_st35"
      />
      <path
        d="M773.3 750.1c-.5-4.4-2.3-9.9-5.4-15.3-6.3-10.8-15.3-17.4-20.2-14.6s-3.8 13.7 2.5 24.6c6.3 10.8 15.3 17.4 20.2 14.6l16.9-9.4c4.9-2.7 3.8-13.7-2.5-24.6-6.3-10.8-15.3-17.4-20.2-14.6l-16.9 9.4"
        className="pl_st29"
      />
      <path
        d="m776.6 738 11.3-6.3M773.1 729.3l10.1-5.7M768.1 723.4l10.8-6.1M762.5 718.5l10.9-6.1"
        className="pl_st30"
      />
    </g>
  </svg>
)
export default SvgEkoIllusDunk3
